import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { LeagueAboutBlockComponent } from './league-about-block/league-about-block.component';
import { GameCardComponent } from './game-card/game-card.component';
import { SvgIconModule, UtilsModule } from '@mtgame/ui';
import { RouterModule } from '@angular/router';
import { TeamBgDirective } from '@shared/directives/team-bg.directive';
import { HeightRatioDirective } from '@shared/directives/height-ratio.directive';
import { LeagueGaloTournamentCardComponent } from '@shared/league-galo-tournament-card/league-galo-tournament-card.component';
import { HockeyLeagueAboutComponent } from '@shared/hockey-league-about/hockey-league-about.component';
import { BasketballLeagueAboutComponent } from '@shared/basketball-league-about/basketball-league-about.component';
import { VolleyballLeagueAboutComponent } from '@shared/volleyball-league-about/volleyball-league-about.component';
import { FootballLeagueAboutComponent } from '@shared/football-league-about/football-league-about.component';
import { RugbyLeagueAboutComponent } from '@shared/rugby-league-about/rugby-league-about.component';

@NgModule({
  imports: [
    CommonModule,
    UtilsModule,
    RouterModule,
    SvgIconModule
  ],
  declarations: [
    LeagueAboutBlockComponent,
    GameCardComponent,
    LeagueGaloTournamentCardComponent,
    TeamBgDirective,
    HeightRatioDirective,
    HockeyLeagueAboutComponent,
    BasketballLeagueAboutComponent,
    VolleyballLeagueAboutComponent,
    FootballLeagueAboutComponent,
    RugbyLeagueAboutComponent,
  ],
  exports: [
    LeagueAboutBlockComponent,
    GameCardComponent,
    LeagueGaloTournamentCardComponent,
    TeamBgDirective,
    HeightRatioDirective,
  ],
})
export class SharedModule {}
